import { FeatureRollout } from '@ms/yammer-data/dist/state/ecsFeatureRollouts/types';
import { useIsFeatureRolloutEnabled } from '@ms/yammer-hooks/dist/featureRollouts';

import { UseUIFeatureCheck } from '../types';

export const useIsPostOnBehalfOfEnabled: UseUIFeatureCheck = () =>
  useIsFeatureRolloutEnabled(FeatureRollout.PostOnBehalfOf);
